var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('html',{staticClass:"\n    has-aside-mobile-transition\n    has-aside-left\n    has-navbar-fixed-top\n    has-aside-expanded\n  "},[_c('body',[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }